import { render, staticRenderFns } from "./host-activity-home.vue?vue&type=template&id=dd8a0862&scoped=true&"
import script from "./host-activity-home.vue?vue&type=script&lang=js&"
export * from "./host-activity-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8a0862",
  null
  
)

export default component.exports